"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ToastContent = void 0;
var _styled = _interopRequireDefault(require("@emotion/styled"));
var _spacing = require("../../../constants/spacing");
/**
 * @deprecated please use @smartsheet/sds-toast-state-service instead. See
 * https://static.smart.ninja/storybook/team-ui-engineering/lodestar-core/mainline/sds-toast-ui/storybook/index.html
 */
const ToastContent = (0, _styled.default)("div")`
    margin: ${_spacing.sizes.small}px ${_spacing.sizes.xLarge}px ${_spacing.sizes.small}px ${_spacing.sizes.small}px;
    align-self: center;
    flex-grow: 1;

    // To allow the Links to properly elide, we need to add some extra stuff:
    // Not hidden, because we want the focus outlines to be visible and they render outside
    // of the bounding box
    overflow: visible;
    // Ensure the container calcs its width.
    min-width: 1px;

    // IE11 flex-bug 2: https://github.com/philipwalton/flexbugs#flexbug-2
    max-width: 100%;
`;
exports.ToastContent = ToastContent;
//# sourceMappingURL=ToastContent.js.map